<template>
  <div id="app" >
    <!-- top头部导航栏 -->
    <header class="appTop">
      <div class="logo">
        <div>
          <el-image class="logo1" :src="src"></el-image>
        </div>
        <div >
          <el-image class="logoName" :src="srcName"></el-image>
          <div class="logoTop">bluefire.top</div>
        </div>
      <div class="city"  >
        <div @click="onColo">
          <i class="el-icon-location" style="color:#C4C4C4"></i>
          <span style="width: 150px;display: inline-block;" >{{code.name}}</span>
        </div>
       <transition name="el-zoom-in-top">
        <div v-show="show" class="transition-box">
        <div style="display: flex;" >
          <div style="width: 150px;height: 500px;text-align:center;overflow-y: auto;margin-right: 30px;">
            <div v-for="(item,index) in cityList" :key="index" >
              <div @click="onClickTitle(item)" style="padding: 10px 0;">{{item.name}}</div>
            </div>
          </div>
          <div class="transition-boxY">
            <div v-for="(item,index) in cityCPList" :key="index" style="width: 200px;">
            <div @click="onClickCity(item)" style="padding: 10px 0;">{{item.name}}</div>  
          </div>
          </div>
        </div>
        </div>
      </transition>
      </div>
      </div>
      <div style="display:flex;width:50%">
        <el-menu  :default-active="$route.path"
          class="el-menu-demo"
          mode="horizontal"
          router
         >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <el-menu-item index="/group">我的团队</el-menu-item>
          <el-menu-item index="/AboutUs">关于我们</el-menu-item>
        </el-menu>
          <!-- <el-input
            placeholder="搜索"
            class="elInput"
            type="text"
            v-model="input3">
            <i slot="prefix" style="color: #676C92;" class="el-input__icon el-icon-search"></i>
            <div slot="suffix" class="suffixDiv">
              <i class="el-input__icon el-icon-user-solid"></i>
            </div>
          </el-input> -->

      </div>
    </header>

    <!-- 内容 -->
    <div style="margin-top:2rem;padding: 25px 0px 0px 0px;" @click="show = false">
      <router-view  :message="urlImg"  :address="code"/>
    </div>
    <!-- 尾部 -->
    <footer class="footer" id="content1" @click="show = false">
        <div v-if="$route.path == '/'">
          <div class="footerText">合作伙伴</div>
          <div >
            <el-image class="partner" :src="partner1"></el-image>
            <el-image class="partner" :src="partner2"></el-image>
            <el-image class="partner" :src="partner3"></el-image>
            <el-image class="partner" :src="partner4"></el-image>
            <el-image class="partner" :src="partner5"></el-image>
            <el-image class="partner" :src="partner6"></el-image>
            <el-image class="partner" :src="partner7"></el-image>
            <!-- <el-image class="partner" :src="partner8"></el-image> -->
          </div>
        </div>
        <div>
          <div class="footerText">联系我们</div>
          <div style="display: flex;">
            <div style="width:70%">
              <table class="descriptions">
                <tr class="descriptions__body"><td>企业名称：蓝色火焰科技成都有限公司</td><td>联系方式：18123399598</td></tr>
                <tr class="descriptions__body"><td>平台产品：特价充话费公众号</td><td>联系地址：四川省高新区萃华路89号国际科技节能大厦-803</td></tr>
              </table>
                <!-- <el-descriptions :column="2">
                  <el-descriptions-item label="企业名称">蓝色火焰科技成都有限公司</el-descriptions-item>
                  <el-descriptions-item label="联系方式">18081042300</el-descriptions-item>
                  <el-descriptions-item label="平台产品">特价充话费公众号</el-descriptions-item>
                  <el-descriptions-item label="联系地址">四川省高新区翠华路89号国际科技节能大厦-803</el-descriptions-item>
                </el-descriptions> -->
            </div>
            <div style="width:20%">
               <el-image class="QRCode" :src="QRCode"></el-image>
            </div>
          </div>
        </div>
        <div class="hrep">
          © 2012-2021 蓝色火焰  成都公网安备 <el-link style="color:red" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蜀ICP备20012242号-1</el-link>
        </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
       src: require('./assets/logo.png'),
       srcName: require('./assets/logoName.png'),
       partner1:require('./assets/partner1.png'),
       partner2:require('./assets/partner2.png'),
       partner3:require('./assets/partner3.png'),
       partner4:require('./assets/partner4.png'),
       partner5:require('./assets/partner5.png'),
       partner6:require('./assets/partner6.png'),
       partner7:require('./assets/partner7.png'),
       partner8:require('./assets/partner8.png'),
       QRCode:require('./assets/QRCode.png'),
       activeIndex: '1',
       input3:"",
       show:false,
       cityList:[],
       cityCPList:[],
       code:{},
       urlImg:[]
    }
  },
  created(){
    this.getApiList()
    
  },
    methods: {
      handleSelect(key, keyPath) {
        console.log(this.$route.path);
      },
      getApiList(){
        let url = this.$route.query
        console.log(url,"rl")
        this.$api.getCity().then(res => {  
          // handle response data  
          if(url.address){
            this.cityList = res.data.data
            let city = res.data.data.find((res)=> res.code == url.address)
            //  this.code= city
            this.onClickCity(city)
          }else{
            this.cityList = res.data.data
            let city = res.data.data.find((res)=> res.name == "北京市")
            //  this.code= city
            this.onClickCity(city)
          }
          console.log(this.cityList,"cityList")
          console.log(res.data.data,"res.data.data")
        
        })  
        .catch(error => {
          // handle error
        });
      },
      onColo(){
        this.show = true
        console.log( this.show )
      },
      onClickTitle(item){
        this.code = item
        this.cityCPList = item.subArrays
        console.log(item)
        // this.$api.upImage(item.code,1).then(res =>{
        //   if(res.data.data[0]){
        //     this.urlImg = res.data.data
        //   }else{
        //     this.urlImg = ""
        //   }
        //   console.log(this.urlImg)
        // })
      },
      onClickCity(item){
        this.code = item
        this.show = false
        this.$api.upImage(item.code,1).then(res =>{
          if(res.data.data[0]){
            this.urlImg = res.data.data
          }else{
            this.urlImg = ""
          }
          console.log(this.urlImg)
        })
         .catch(error => {  
          // handle error  
        });
      }
    }
}
</script>

<style scoped>
  /* @import "./style/top.scss"; */
  @import "./style/footer.scss";
  .appTop{
  height: 2rem;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  /* overflow: hidden; */
  padding: 10px 0px 10px 0px;
  position: fixed;
  top: 0;
  z-index: 150;
}
.logo{
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.logo1{
  height: 100%;
  width: 1.4rem;
  margin-right: 10px;
}
.logoName{
  width: 3.9rem;
  /* width: 100%; */
  height: .85rem;
  position: relative;
  top: 1px;
}
.logoTop{
  color:#C3C9C8;
  font-size: 0.65rem;
  font-family: "ku";
  position: relative;
  top: -1.5px;
}
.suffixDiv{
  width: 35px;
  height: 35px;
  margin-top: 2px;
  background: #ffffff;
  border-radius: 50%;
}
.elInput{
  margin-left: 20px;
  width: 12rem;
  border-radius: 20% !important;
}

/deep/ .el-menu--horizontal>.el-menu-item{
  height: 2.5rem;
  color:#676C92;
   font-family: "黑体";
  line-height: 2.6rem;
  font-weight: 900;
}
/deep/ .el-menu.el-menu--horizontal{
  border-bottom: #ffffff;
}
/deep/ .el-menu--horizontal>.el-menu-item.is-active{
  font-weight: 900;
  font-family: "黑体";
  color: #498FFD;
  border-bottom: 2px solid #498FFD !important;
  /* border-image:linear-gradient(to right,#498FFD,transparent ) 10 10; */

}
/deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #498FFD;
}
/deep/ .el-menu-item {
  padding: 0px;
  margin:0 15px !important;
}
 /deep/ .el-icon-user-solid{
 position: relative;
 bottom: 3px;
 color: #676C92;
}
/deep/ .el-input__inner{
  border-radius: 20px;
  background-color: #F1F5FE ;
  color: #676C92;
}

.city{
  line-height: 40px;
  position: relative;
  left: 40px;
  cursor: pointer; 
}
.transition-box{
  position: absolute;
  /* top: 10px; */
  z-index: 500;
  min-height: 200px;
  /* width: 700px; */
  border: 1px solid #f4f8ff;
  display: flex;
  flex-direction: row;
  flex-wrap:nowrap;
  margin-left: -50px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
   background:#ffff;
}
.transition-boxY{
  /* position: absolute; */
  /* top: 10px; */
  z-index: 500;
  width: 600px;
  display: flex;
  flex-direction: row;
  flex-wrap:wrap;

}

#app {
  margin: 0;
  padding: 0;
}


</style>



// WEBPACK FOOTER //
// src/App.vue